import React, {Dispatch, SetStateAction} from "react";
import {DataProviderProxy} from "ra-core";
import SortableImageList from "../../common/image/SortableImageList";
import {TempFileData} from "../../modules/temporaryFileModule";
import {ListPhotosType} from "../../common/image/arrayUtil";
import {ResourceNames} from "../../config/const";
import {ApiProductVariantItemImageCombination} from "../../openapi";

export interface ProductVariantImageProps {
    dataProvider: DataProviderProxy;
    setPathData: Dispatch<SetStateAction<Array<TempFileData>>>;
    pathData: TempFileData[];
    setImages: Dispatch<SetStateAction<Array<ListPhotosType> | undefined>>;
    imageCombo?: ApiProductVariantItemImageCombination[]
    setImageCombo?: Dispatch<SetStateAction<ApiProductVariantItemImageCombination[]>>;
    images: ListPhotosType[] | undefined;
    variantItemId: number;
    unShowDelete?: boolean;
}

const VariantImage: React.FC<ProductVariantImageProps> = (props) => {
    return (
        <>
            <SortableImageList imageArray={props.images}
                               dataProvider={props.dataProvider}
                               resource={ResourceNames.PRODUCT_VARIANT_ITEM_IMAGES}
                               isUpdating={!!props.variantItemId}
                               setPathData={props.setPathData}
                               pathData={props.pathData}
                               setImages={props.setImages}
                               imageSourceName={ResourceNames.PRODUCT_VARIANT_ITEM_IMAGES}
                               maxFileCount={2}
                               showSortBox={false}
                               unShowDelete={props.unShowDelete}
            />
        </>
    );
}

export default VariantImage
